export default __webpack_public_path__ + "static/media/NityaFB.29cbe5e9.png";